/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_NovemberInputs */

const es_months_november = /** @type {(inputs: Months_NovemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noviembre`)
};

const en_months_november = /** @type {(inputs: Months_NovemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`November`)
};

/**
* | output |
* | --- |
* | "November" |
*
* @param {Months_NovemberInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_november = /** @type {((inputs?: Months_NovemberInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_NovemberInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_november(inputs)
	return en_months_november(inputs)
});
export { months_november as "months.november" }